import React from 'react'
import styled from 'styled-components'

import { Checkbox } from './'

const Wrapper = styled.div`
    display: flex;
    direction: ${prop => prop.directions};
`

const Option = styled.div`
    font-size: 11px !important;
    color: ${props => props.theme.colors.textBold};
    
    ${props => props.direction === 'row' && `
        margin-right: 10px;
    `}
    ${props => props.column === 'row' && `
        margin-bottom: 10px;
    `}
`

export const CheckboxGroup = ({ direction, options, checkeds, onCheck, onChange }) => {

    const handleCheck = (value, checked) => {
        const newCheckeds = [...checkeds]
        const index = newCheckeds.indexOf(value)
        if (index !== -1) {
            newCheckeds.splice(index, 1)
        } else {
            newCheckeds.push(value)
        }
        if (onCheck) {
            onCheck(newCheckeds)
        }
        if (onChange) {
            onChange(value, checked)
        }
    }

    return (
        <Wrapper direction={direction}>
            {options && options.map((option, key) => {
                const isChecked = checkeds.indexOf(option.value) !== -1
                return (
                    <Option direction={direction}
                        key={key}>
                        <Checkbox
                            checked={isChecked}
                            onCheck={(checked) => handleCheck(option.value, checked)}
                        >
                            {option.name}
                        </Checkbox>
                    </Option>
                )
            })}
        </Wrapper>
    )
}